import { Link } from "react-router-dom";

export default function RolesTicker({ jobs, total, catCount }) {
  const items = jobs.length ? [...jobs, ...jobs] : [];
  const stats = [
    { n: total > 0 ? `${total}+` : "600+", l: "Open roles", id: "open-roles" },
    { n: String(catCount || 11), l: "Career fields", id: "career-fields" },
    { n: "50", l: "States covered", id: "states-covered" },
    { n: "2 days", l: "Avg response time", id: "avg-response-time" },
  ];
  return (
    <section className="bg-[#FAF7EE] border-b border-[#0F2A1F]/10" data-testid="home-ticker">
      {items.length > 0 && (
        <div className="overflow-hidden bg-[#D4AF37] text-[#0F2A1F] py-3">
          <div className="ticker w-max text-sm font-semibold whitespace-nowrap">
            {items.map((j, i) => (
              <Link key={`${j.id}-${i}`} to={`/apply/${j.id}`} className="inline-flex items-center gap-2 hover:underline">
                <span className="h-1.5 w-1.5 rounded-full bg-[#0F2A1F]" /> Now hiring: {j.title} · {j.location} · {j.salary_range}
              </Link>
            ))}
          </div>
        </div>
      )}
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-8 md:py-10 grid grid-cols-2 md:grid-cols-4 gap-6">
        {stats.map((s) => (
          <div key={s.id} data-testid={`hero-stat-${s.id}`}>
            <div className="text-4xl md:text-5xl font-bold text-[#0F2A1F] font-serif">{s.n}</div>
            <div className="mt-1 text-[11px] tracking-[0.2em] uppercase text-[#0F2A1F]/55 font-semibold">{s.l}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
